import type { TFunction } from 'i18next';

const GATEWAY_PROTECTION_PREFIX = 'Gateway Protection';

export type CustomFeeLike = {
  id: string;
  description: string;
  amountCents: number;
  isRecurring: boolean;
  enabled: boolean;
};

export const isGatewayProtectionFee = (description: string): boolean =>
  description.startsWith(GATEWAY_PROTECTION_PREFIX);

export const extractCustomFeeDomain = (description: string): string | null => {
  const middleDot = description.indexOf('·');
  if (middleDot >= 0) {
    const domain = description.slice(middleDot + 1).trim();
    return domain.length > 0 ? domain : null;
  }
  const paren = description.match(/\(([^)]+)\)/);
  return paren?.[1]?.trim() || null;
};

export const enabledCustomFees = (fees: CustomFeeLike[] | null | undefined): CustomFeeLike[] =>
  (fees ?? []).filter((fee) => fee.enabled);

export const resolveCustomFeeLabel = (description: string, t: TFunction<'billing'>): string => {
  if (!isGatewayProtectionFee(description)) return description;
  const domain = extractCustomFeeDomain(description);
  if (domain) return t('customFees.additionalServiceWithDomain', { domain });
  return t('customFees.additionalService');
};
